export class DeleteRelNotificheIN {
    idTabNotifica: number
}
